import { VerticalView } from 'src/components/FlexViews';
import styled from 'styled-components';

export const PageWrapper = styled(VerticalView)`
  background-color: #090d12;
  min-height: 100%;
  padding: 56px 20px;
  scrollbar-width: none;
  -ms-overflow-style: none;
  position: relative;
  overflow: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;
